import { render, staticRenderFns } from "./CadastroMotorista.vue?vue&type=template&id=2feb5755&scoped=true"
import script from "./CadastroMotorista.vue?vue&type=script&lang=js"
export * from "./CadastroMotorista.vue?vue&type=script&lang=js"
import style0 from "./CadastroMotorista.vue?vue&type=style&index=0&id=2feb5755&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2feb5755",
  null
  
)

export default component.exports